import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import NoSSR from 'react-no-ssr';
import { withRouter } from 'next/router';

import HandOffLink from '../../../../utils/urls/HandOffLink';

import HeaderAccountSection from './HeaderAccountSection';

import Masthead from '../../DesktopHeader/Masthead';
import TextInputWithIcon from '../../DesktopHeader/TextInputWithIcon';

import { openNav, closeNav, navFinished } from '../../../../redux/nav';
import { searchRequested } from '../../../../redux/search';

import CategoryNav from '../CategoryNav/CategoryNav';
import Logo from '../../../../assets/svg/Logo';
import MagnifyingGlass from '../../../../assets/svg/MagnifyingGlass';

const NavBar = styled.nav`
  display: flex;
  flex-direction: column;
`;

const StyledLogo = styled(Logo)`
  margin-top: 0.5rem;
`;

export class DesktopHeader extends Component {
  static propTypes = {
    closeNav: PropTypes.func.isRequired,
    navFinished: PropTypes.func.isRequired,
    openNav: PropTypes.func.isRequired,
    searchId: PropTypes.string,
  };

  static defaultProps = {
    searchId: 'main',
  };

  routeSelectedNode = ({ href, path }) => {
    const { navFinished } = this.props;
    navFinished(href, path);
  };

  onSearchSubmit = query => {
    const { searchRequested, searchId } = this.props;
    searchRequested(query, searchId);
  };

  render() {
    const {
      openNav,
      closeNav,
      nodes,
      router: {
        query: { q: searchQuery },
      },
    } = this.props;

    return (
      <NavBar>
        <Masthead
          left={
            <TextInputWithIcon
              placeholder="Search"
              defaultValue={searchQuery}
              submitIcon={<MagnifyingGlass />}
              onSubmit={this.onSearchSubmit.bind(this)}
            />
          }
          center={
            <HandOffLink href="/" identifier="header-home">
              <StyledLogo width="8rem" height="2.25rem" />
            </HandOffLink>
          }
          right={
            <NoSSR>
              <HeaderAccountSection />
            </NoSSR>
          }
        />
        <CategoryNav
          openNav={openNav}
          closeNav={closeNav}
          nodes={nodes}
          onNodeClick={this.routeSelectedNode}
        />
      </NavBar>
    );
  }
}

const mapDispatchToProps = {
  searchRequested,
  openNav,
  closeNav,
  navFinished,
};

export default connect(null, mapDispatchToProps)(withRouter(DesktopHeader));
